import { Component, OnInit } from '@angular/core';
import {GeneralService} from '../../services/general.service';
import {AppCommunicationService} from '../../services/app-communication.service';
import {I18nService} from '../../../shared/i18n';

@Component({
  selector: 'app-faq-view',
  templateUrl: './faq-view.component.html',
  styleUrls: ['./faq-view.component.scss']
})
export class FaqViewComponent implements OnInit {
    data = [];
    constructor(
        private i18nService: I18nService,
        private _generalService: GeneralService,
        private _appCommunicationService: AppCommunicationService
    ) {
    }

    ngOnInit() {
        setTimeout(() => {
            this._appCommunicationService.loadingOn(this.i18nService.getTranslation('Downloading report'));
        });
        this.loadAllFaqs()
    }

    loadAllFaqs() {
        this._generalService
            .getPublicFaqForIsbn()
            .subscribe(faqs => {
                this.data = faqs;
                this._appCommunicationService.loadingOff();
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/+app-custom/views/faq-view/faq-view.component.ts